import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Firms from "@/pages/Firms";
import Clients from "@/pages/Clients";
import ClientLedger from "@/pages/ClientLedger";
import Contacts from "@/pages/Contacts";
import Cases from "@/pages/Cases";
import Invoices from "@/pages/Invoices";
import InvoiceBuilder from "@/pages/InvoiceBuilder";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Reports from "@/pages/Reports";
import RunningAccount from "@/pages/RunningAccount";
import TdsRegister from "@/pages/TdsRegister";
import Statements from "@/pages/Statements";
import SettingsPage from "@/pages/SettingsPage";
import ClientPortal from "@/pages/ClientPortal";

function OwnerOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user?.role === "clerk" ? <Navigate to="/dashboard" replace /> : children;
}

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/portal/:token" element={<ClientPortal />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoices/new" element={<InvoiceBuilder />} />
        <Route path="/invoices/:invoiceId" element={<InvoiceDetail />} />
        <Route path="/invoices/:invoiceId/edit" element={<InvoiceBuilder />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/firms" element={<Firms />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:clientId" element={<ClientLedger />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/running-accounts" element={<RunningAccount />} />
        <Route path="/tds" element={<TdsRegister />} />
        <Route path="/statements" element={<Statements />} />
        <Route path="/settings" element={<OwnerOnly><SettingsPage /></OwnerOnly>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
